export default __webpack_public_path__ + "static/media/19.76ae82a4.jpeg";